// @ts-nocheck
import React, { useCallback } from 'react';
import { FilterItem } from '../../../components';
import Field from '../../../components/card/Field';
import { CommonFilter } from '../../../components/hoc/common/handbook/CommonFilter';
import VehicleModelSelect from '../../../components/selects/VehicleModelSelect';
import VehicleIssueGroupSelect from '../../../components/selects/VehicleIssueGroupSelect';
export const OverhaulTypeFilter = props => {
  const Filter = useCallback(filterProps => CommonFilter({
    ...filterProps,
    ...props
  }), [props]);
  return <Filter>
      {(values, changeValue) => <>
          <FilterItem>
            <Field mBottomNone>
              <VehicleModelSelect size="small" value={values.vehicleModelId} onChange={async value => changeValue('vehicleModelId', value)} />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <VehicleIssueGroupSelect size="small" value={values.vehicleIssueGroupId} onChange={async value => changeValue('vehicleIssueGroupId', value)} />
            </Field>
          </FilterItem>
        </>}
    </Filter>;
};
export default OverhaulTypeFilter;
